module.exports = __webpack_public_path__ + "img/10.8d4f57ab.png";